var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLogin && _vm.isMounted
    ? _c("div", { staticClass: "site-header-info__row" }, [
        _c("p", { staticClass: "site-header-info__mailmag" }, [
          _c(
            "a",
            { attrs: { href: _vm.path.signup, id: "conversion_header" } },
            [_vm._v("無料会員登録")]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "site-header-info__member" }, [
          _c("a", { attrs: { href: _vm.path.login } }, [
            _c("svg", { staticClass: "icon-member" }, [
              _c("use", { attrs: { "xlink:href": "#icon_sign_in" } })
            ]),
            _vm._v("ログイン")
          ])
        ])
      ])
    : _vm.isMounted
    ? _c("div", { staticClass: "site-header-info__row" }, [
        _c("p", { staticClass: "site-header-info__logout" }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:void(0);" },
              on: {
                click: function($event) {
                  return _vm.logout($event)
                }
              }
            },
            [
              _c("svg", { staticClass: "icon-logout" }, [
                _c("use", { attrs: { "xlink:href": "#icon_sign_in" } })
              ]),
              _vm._v("ログアウト")
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "site-header-info__mypage" }, [
          _c("a", { attrs: { href: _vm.path.profile } }, [
            _c("i", { staticClass: "fas fa-user" }),
            _vm._v("マイページ")
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }